import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");

// Views - News
// const News = () => import("@/views/news/GestioneNews");
// const Elenco_news = () => import("@/views/news/Elenco_news");
const NewsOperativeBroker = () => import("@/views/news/NewsOperativeBroker");
const GestioneNewsBroker = () => import("@/views/news/GestioneNewsBroker");

// Views - Documentale
const Documentale = () => import("@/views/documentale/Documentale");
const DettagliIntermediario = () =>
  import(
    /* webpackChunkName: "Documentale" */ "@/views/documentale/DettagliIntermediario"
  );
const DettagliProponente = () =>
  import(
    /* webpackChunkName: "Documentale" */ "@/views/documentale/DettagliProponente"
  );
const Rilievi_Audit = () =>
  import(
    /* webpackChunkName: "Documentale" */ "@/views/documentale/Rilievi_Audit"
  );

// Views - Formazione
const AdminFormazione = () =>
  import(
    /* webpackChunkName: "Formazione" */ "@/views/formazione/AdminFormazione"
  );
const Formazione = () =>
  import(/* webpackChunkName: "Formazione" */ "@/views/formazione/Formazione");
const Corso = () =>
  import(/* webpackChunkName: "Formazione" */ "@/views/formazione/Corso");
const ModificaCorso = () =>
  import(
    /* webpackChunkName: "Formazione" */ "@/views/formazione/ModificaCorso"
  );

// Views - Commerciale
const AdminCommerciale = () =>
  import(
    /* webpackChunkName: "Commerciale" */ "@/views/commerciale/AdminCommerciale"
  );
const Commerciale = () =>
  import(
    /* webpackChunkName: "Commerciale" */ "@/views/commerciale/Commerciale"
  );
const Sezione = () =>
  import(/* webpackChunkName: "Commerciale" */ "@/views/commerciale/Sezione");
const Comunicazione = () =>
  import(
    /* webpackChunkName: "Commerciale" */ "@/views/commerciale/Comunicazione"
  );
const ModificaContenuti = () =>
  import(
    /* webpackChunkName: "Commerciale" */ "@/views/commerciale/ModificaContenuti"
  );
// View - Amministrazione
const Amministrazione = () =>
  import(
    /* webpackChunkName: "Amministrazione" */ "@/views/amministrazione/amministrazione"
  );

// Views - Statistiche
const Statistiche = () =>
  import(
    /* webpackChunkName: "Statistiche" */ "@/views/statistiche/Statistiche"
  );
const Accessi_stat = () => import("@/views/statistiche/Accessi_stat");
const GeneratoreFirme = () => import("@/views/GeneratoreFirme/abysign");
const Calendario = () => import("@/views/Calendario/calendario");
const Kanban = () => import("@/views/KanbanContatti/KanbanBoard");
const StatistichePortali = () =>
  import(
    /* webpackChunkName: "Statistiche" */ "@/views/statistiche/StatistichePortali"
  );
const Crm = () => import("@/views/crm/crm");

// E-learning CRM
const ElearningCorso = () => import("@/views/e-learning/elearningCorso");
const ElearningDashboard = () =>
  import("@/views/e-learning/elearningDashboard");
const ElearningLogin = () => import("@/views/e-learning/elearningLogin");

const Profilo = () => import("@/views/pages/Profilo");
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/",
      component: TheContainer,
      children: [
        { path: '', redirect: 'Crm' },
        {
          path: 'Crm', component: Crm, name: 'Crm',
          meta: {
            transition: "fade",
          },
        },
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "Documentale",
          name: "Documentale",
          component: Documentale,
        },
        {
          path: "Documentale/Intermediario/",
          name: "DettagliIntermediario",
          props: true,
          component: DettagliIntermediario,
        },
        {
          path: "Documentale/Proponente/",
          name: "DettagliProponente",
          props: true,
          component: DettagliProponente,
        },
        {
          path: "Documentale/Dettaglio/",
          name: "Rilievi_Audit",
          props: true,
          component: Rilievi_Audit,
        },
        {
          path: "StatistichePortali",
          name: "StatistichePortali",
          component: StatistichePortali,
        },
        {
          path: "NewsOperative",
          name: "NewsOperativeBroker",
          component: NewsOperativeBroker,
        },
        {
          path: "GestioneNewsBroker",
          name: "GestioneNewsBroker",
          component: GestioneNewsBroker,
        },
        {
          path: "Formazione",
          name: "Formazione",
          component: Formazione,
        },
        {
          path: "Formazione/Corso/:corso",
          name: "Corso",
          props: true,
          component: Corso,
        },
        {
          path: "AdminFormazione",
          name: "AdminFormazione",
          props: true,
          component: AdminFormazione,
        },
        {
          path: "AdminFormazione/Modifica/",
          name: "ModificaCorso",
          props: true,
          component: ModificaCorso,
        },
        {
          path: "Commerciale",
          name: "Commerciale",
          component: Commerciale,
        },
        {
          path: "Commerciale/:contenuto",
          name: "Sezione",
          props: true,
          component: Sezione,
        },
        {
          path: "Commerciale/Comunicazione/:notizia",
          name: "Comunicazione",
          props: true,
          component: Comunicazione,
        },
        {
          path: "AdminCommerciale/Modifica/",
          name: "ModificaContenuti",
          props: true,
          component: ModificaContenuti,
        },
        {
          path: "AdminCommerciale/:settore",
          name: "AdminCommerciale_settore",
          props: true,
          component: AdminCommerciale,
        },
        {
          path: "Amministrazione",
          name: "Amministrazione",
          component: Amministrazione,
        },
        {
          path: "AclPolicies",
          name: "AclPolicies",
          component: () => import("@/views/admin/AclPolicies.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "Profilo",
          name: "Profilo",
          component: Profilo,
        },
        {
          path: "Accessi_stat",
          name: "Accessi_stat",
          component: Accessi_stat,
        },
        {
          path: "GeneratoreFirme",
          name: "abysign",
          component: GeneratoreFirme,
        },
        {
          path: "Calendario",
          name: "calendario",
          component: Calendario,
        },
        {
          path: "Kanban",
          name: "kanbanBoard",
          component: Kanban,
        },
        {
          path: "Statistiche/:portale",
          name: "Statistiche",
          props: true,
          component: Statistiche,
        },
      ],
      meta: {
        requiresAuth: true,
        transition: "fade",
      },
    },
    {
      path: "/e-learning",
      name: "E-learning",
      component: ElearningDashboard,
      meta: {
        public: true,
        requiresAuthElearning: true,
        transition: "fade",
      },
    },
    {
      path: "/e-learningCorso/",
      name: "E-learningCorso",
      component: ElearningCorso,
      props: true,
      meta: {
        public: true,
        requiresAuthElearning: true,
        transition: "fade",
      },
    },
    {
      path: "/e-learning-login",
      name: "LoginElearning",
      component: ElearningLogin,
      meta: {
        public: true,
        transition: "fade",
      },
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        public: true,
        onlyWhenLoggedOut: true,
      },
    },
    { path: "/404", name: "Page404", component: Page404 },
    { path: "/500", name: "Page500", component: Page500 },
    { path: "*", redirect: { name: "Page404" } },
  ];
}
router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requiresAuth)) {
    return isAuthenticated() ? next() : next({ path: '/login', replace: true });
  }
  if (to.matched.some(r => r.meta.requiresAuthElearning)) {
    return (sessionStorage.getItem('tokenElearning') || isAuthenticated())
      ? next()
      : next({ path: '/e-learning-login', replace: true }); // se la usi
  }
  next();
});

// // Funzione per controllare se l'utente è autenticato nella piattaforma di e-learning
// function isAuthenticatedElearning() {
//   return sessionStorage.getItem("tokenElearning") !== null;
// }
function isAuthenticated() {
  if (localStorage.getItem("utente") == "ok") {
    // let userId = localStorage.getItem("userID");
    // let Nominativo = JSON.parse(
    //   localStorage.getItem("chisono_data")
    // ).Nominativo;
    // sessionStorage.setItem("Nominativo", Nominativo);
    // sessionStorage.setItem("Learning", true);
    // sessionStorage.setItem("learningUserId", userId);

    // sessionStorage.setItem("tokenElearning", "SLKJDO20300SLXPA...A38902");
    return true;
  } else {
    return false;
  }
}

router.onError((error) => {
  console.log("Errore di caricamento " + error.message);
  const targetPath = router.history.pending.fullPath;
  history.replaceState("", "", targetPath);
  router.replace(targetPath);
});

export default router;
